module.exports = __webpack_public_path__ + "5835ec3b2d9192fc48be70ec225e1589.png";